// src/pages/Dashboard.js
import React, { useState } from 'react';
import CrearUsuario from './CrearUsuario';
import CrearTecnico from './CrearTecnico';
import ListaTecnicos from './ListaTecnicos';
import { UserPlus, ClipboardList, LogOut, Menu } from 'lucide-react';

const Dashboard = ({ usuario, onLogout }) => {
  const [seccion, setSeccion] = useState('reportes');
  const [menuAbierto, setMenuAbierto] = useState(true);

  const cambiarSeccion = (seccionElegida) => {
    setSeccion(seccionElegida);
  };

  return (
    <div className="flex h-screen">
      {/* Menú lateral */}
      <div className={`flex flex-col justify-between bg-gray-800 text-white transition-all duration-300 ${menuAbierto ? 'w-64' : 'w-16'}`}>
        <div>
          <div className="p-4 flex justify-between items-center">
            <span className={`font-bold text-lg transition-opacity duration-200 ${menuAbierto ? 'opacity-100' : 'opacity-0 hidden'}`}>Zonatek</span>
            <button onClick={() => setMenuAbierto(!menuAbierto)} className="text-white">
              <Menu size={20} />
            </button>
          </div>
          <nav className="flex flex-col space-y-2 p-4">
            <span className={`text-sm text-gray-400 ${menuAbierto ? '' : 'hidden'}`}>Ajustes</span>
            {usuario.rol === 'admin' && (
              <>
                <button onClick={() => cambiarSeccion('crear-usuario')} className="flex items-center gap-2 hover:underline">
                  <UserPlus size={18} />
                  <span className={`${menuAbierto ? '' : 'hidden'}`}>Agregar usuario</span>
                </button>
                <button onClick={() => cambiarSeccion('crear-tecnico')} className="flex items-center gap-2 hover:underline">
                  <UserPlus size={18} />
                  <span className={`${menuAbierto ? '' : 'hidden'}`}>Agregar técnico</span>
                </button>
              </>
            )}
            <span className={`mt-4 text-sm text-gray-400 ${menuAbierto ? '' : 'hidden'}`}>Reportes</span>
            <button onClick={() => cambiarSeccion('reportes')} className="flex items-center gap-2 hover:underline">
              <ClipboardList size={18} />
              <span className={`${menuAbierto ? '' : 'hidden'}`}>Listado de técnicos</span>
            </button>
          </nav>
        </div>
        <div className="p-4 border-t border-gray-700">
          <button onClick={onLogout} className="flex items-center gap-2 text-sm text-red-500 hover:underline w-full">
            <LogOut size={18} />
            <span className={`${menuAbierto ? '' : 'hidden'}`}>Cerrar sesión</span>
          </button>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="flex-1 p-6 overflow-auto">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-xl font-bold">Panel Zonatek</h1>
        </div>

        {seccion === 'crear-usuario' && usuario.rol === 'admin' && (
          <CrearUsuario token={usuario.token} />
        )}

        {seccion === 'crear-tecnico' && usuario.rol === 'admin' && (
          <CrearTecnico token={usuario.token} />
        )}

        {seccion === 'reportes' && (
          <ListaTecnicos token={usuario.token} />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
